module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/modal-profile-1-image-1848ced39c636cf38119d71d5892c670.png";